import { render, staticRenderFns } from "./FirstStepsLayout.vue?vue&type=template&id=d5896ef0&scoped=true&"
import script from "./FirstStepsLayout.vue?vue&type=script&lang=js&"
export * from "./FirstStepsLayout.vue?vue&type=script&lang=js&"
import style0 from "./FirstStepsLayout.vue?vue&type=style&index=0&id=d5896ef0&prod&scoped=true&lang=css&"
import style1 from "./FirstStepsLayout.vue?vue&type=style&index=1&id=d5896ef0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5896ef0",
  null
  
)

export default component.exports